/**
 * RTCPeerConnection tap (009). mediasoup-client does not expose its peer
 * connections, so — only when debug is enabled — we wrap the constructor to
 * collect every PC the page creates, then read getStats() off them in the
 * collector. Installed once, before mediasoup creates any transport.
 */
const pcs = new Set<RTCPeerConnection>()
let installed = false

export function installPcTap(): void {
  if (installed) return
  if (typeof window === 'undefined' || typeof window.RTCPeerConnection !== 'function') return
  installed = true

  const Orig = window.RTCPeerConnection
  const Wrapped = function (this: unknown, ...args: unknown[]) {
    const pc = new (Orig as unknown as new (...a: unknown[]) => RTCPeerConnection)(...args)
    pcs.add(pc)
    pc.addEventListener('connectionstatechange', () => {
      if (pc.connectionState === 'closed') pcs.delete(pc)
    })
    return pc
  } as unknown as typeof RTCPeerConnection

  Wrapped.prototype = Orig.prototype
  window.RTCPeerConnection = Wrapped
}

/** Live peer connections collected since the tap was installed. */
export function getPeerConnections(): RTCPeerConnection[] {
  return [...pcs]
}
